import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useToast } from "@chakra-ui/react";
import "./layout.css";
// Main components
import MainTopBar from "../topbar/topbar";
import MainMenu from "../menu/menu";
import Breadscrum from "../breadscrum/breadscrum";
// import MainBottomBar from "../bottombar/bottombar";
// Components
import Loading from "../../../components/common/loading/loading";
// Actions
import * as authActions from "../../../redux/actions/auth";
// Utils
import { getToastOpt } from '../../../utils/utils';

const MainLayout = ({ isLoading, setIsLoading, children }) => {
  const dispatch = useDispatch();
  const toast = useToast();
  // Selectors
  const user = useSelector(state => state.authReducer.user);

  useEffect(() => {

    // Check logged user
    if (user === null) {
      // Try to login
      setIsLoading(true);
      dispatch(authActions.getUser()).then(
        (response) => {
          // Cool!
          setIsLoading(false);
        },
        (err) => {
          toast(getToastOpt({
            title: `Error d'autenticació`,
            description: err,
            status: "error",
          }));
        }
      );          
    }
  }, []);

  return (
    <div className="page">
      <div className="page-outer">
        <MainTopBar />
        <div className="page-inner">
          <div id="main-layout">
            <MainMenu />
            <div id="main-layout-rightside">
              <Breadscrum />
              {children}
            </div>
          </div>
        </div>
        {/* <MainBottomBar /> */}
        {isLoading && <Loading />}
      </div>
    </div>
  );
};

export default MainLayout;
